import { render } from "./Biweekly.vue?vue&type=template&id=33525ed4"
import script from "./Biweekly.vue?vue&type=script&lang=js"
export * from "./Biweekly.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__